import { Palette } from '@mui/material';
import { rem } from '@core-web/typography';
import scrollUpArrowEnabled from '@assets/logo/scroll_up_enabled.png';
import scrollUpArrowDisabled from '@assets/logo/scroll_up_disabled.png';
import scrollDownArrowEnabled from '@assets/logo/scroll_down_enabled.png';
import scrollDownArrowDisabled from '@assets/logo/scroll_down_disabled.png';
import scrollLeftArrowDisabled from '@assets/logo/scroll_left_disabled.png';
import scrollRightArrowDisabled from '@assets/logo/scroll_right_disabled.png';
import { CSSObject } from '@emotion/react';

const SCROLLBAR_SIZE = 12;

export const ScrollBarStyle = (palette: Palette): CSSObject => {
  return {
    '&::-webkit-scrollbar': {
      width: rem(SCROLLBAR_SIZE),
      height: rem(SCROLLBAR_SIZE),
      borderRadius: rem(2),
      boxShadow: `0px 2px 4px -2px rgba(16, 24, 40, 0.06), 0px 4px 8px -2px rgba(16, 24, 40, 0.10)`,
      padding: rem(8),
      backGroundColor: palette.colors.grey_25,
    },
    '&::-webkit-scrollbar-track': {
      backGroundColor: palette.colors.white,
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: palette.colors.grey_400,
      borderRadius: rem(30),
      border: `2px solid transparent`,
      backgroundClip: 'content-box',

      '&:hover': {
        backgroundColor: palette.colors.orange_400,
      },
    },
    '&::-webkit-scrollbar-button': {
      height: '16px',
      width: '12px',

      '&:vertical:start:decrement': {
        backgroundImage: `url('${scrollUpArrowEnabled}')`,
      },

      '&:vertical:end:increment': {
        backgroundImage: `url('${scrollDownArrowEnabled}')`,
      },

      '&:horizontal:start:decrement': {
        backgroundImage: `url('${scrollLeftArrowDisabled}')`,
      },

      '&:horizontal:end:increment': {
        backgroundImage: `url('${scrollRightArrowDisabled}')`,
      },

      '&:vertical:start:increment, &:vertical:end:decrement, &:horizontal:start:increment, &:horizontal:end:decrement':
        {
          display: 'none',
        },
    },

    '&.isAtTop::-webkit-scrollbar-button': {
      '&:vertical:start:decrement': {
        backgroundImage: `url('${scrollUpArrowDisabled}')`,
      },
      '&:horizontal:start:decrement': {
        backgroundImage: `url('${scrollUpArrowDisabled}')`,
      },
    },
    '&.isAtBottom::-webkit-scrollbar-button': {
      '&:vertical:end:increment': {
        backgroundImage: `url('${scrollDownArrowDisabled}')`,
      },
      '&:horizontal:start:decrement': {
        backgroundImage: `url('${scrollUpArrowDisabled}')`,
      },
    },
  };
};
